import { render } from "./B2bTableMenuGenralsEmit.vue?vue&type=template&id=2cd39209&scoped=true&lang=pug"
import script from "./B2bTableMenuGenralsEmit.vue?vue&type=script&lang=js"
export * from "./B2bTableMenuGenralsEmit.vue?vue&type=script&lang=js"

import "./B2bTableMenuGenralsEmit.vue?vue&type=style&index=0&id=2cd39209&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cd39209"]])

export default __exports__